// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var JsxRuntime = require("react/jsx-runtime");
var Campaign$ReactHooksTemplate = require("../surveys/campaign.res.js");
var SurveyDetail$ReactHooksTemplate = require("../surveys/surveyDetail.res.js");
var ResponseReport$ReactHooksTemplate = require("./ResponseReport.res.js");
var MultiSelectDropDown$ReactHooksTemplate = require("../common/MultiSelectDropDown.res.js");

function ResponseReportForm(props) {
  var template = props.template;
  var survey = ResponseReport$ReactHooksTemplate.survey(template);
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsx("div", {
                                  children: "Response Report Fields",
                                  className: "text-sm font-bold"
                                }),
                            className: "flex gap-1 items-center w-full"
                          }),
                      className: "flex mb-20-px items-center"
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("div", {
                                    children: "Survey",
                                    className: "text-sm font-medium w-1/5"
                                  }),
                              JsxRuntime.jsxs("select", {
                                    children: [
                                      JsxRuntime.jsx("option", {
                                            children: "Select Survey",
                                            disabled: true,
                                            value: "Select Survey"
                                          }, "0"),
                                      $$Array.of_list(Belt_List.map(props.surveys, (function (survey) {
                                                  return JsxRuntime.jsx("option", {
                                                              children: SurveyDetail$ReactHooksTemplate.name(survey),
                                                              value: SurveyDetail$ReactHooksTemplate.name(survey)
                                                            }, String(SurveyDetail$ReactHooksTemplate.id(survey)));
                                                })))
                                    ],
                                    className: "block border px-3 py-2 bordergray-400\n                      w-3/5 bg-white rounded capitalize mr-6 text-sm",
                                    placeholder: "Select Survey",
                                    value: survey !== undefined ? SurveyDetail$ReactHooksTemplate.name(survey) : "Select Survey",
                                    onChange: Curry._1(props.handleResponseReportSurveyChange, template)
                                  })
                            ],
                            className: "flex gap-1 items-center w-full"
                          }),
                      className: "flex mb-30-px items-center"
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("div", {
                                    children: "Campaigns",
                                    className: "text-sm font-medium w-1/5 mt-2"
                                  }),
                              JsxRuntime.jsx(MultiSelectDropDown$ReactHooksTemplate.make, {
                                    defaultPlaceholder: "Select Campaigns",
                                    options: Belt_List.map(props.campaigns, Campaign$ReactHooksTemplate.name),
                                    selectedOptions: Belt_List.map(ResponseReport$ReactHooksTemplate.campaigns(template), Campaign$ReactHooksTemplate.name),
                                    handleChange: Curry._1(props.handleResponseReportCampaignChange, template)
                                  })
                            ],
                            className: "flex gap-1 items-start w-full"
                          }),
                      className: "flex mb-30-px items-center"
                    })
              ]
            });
}

var make = ResponseReportForm;

exports.make = make;
/* react/jsx-runtime Not a pure module */
